<template>
  <div>
    <iframe
      class="video"
      width="480"
      height="390"
      :src="`https://www.youtube.com/embed/${videoId}`"
      title="Little Ant Promo"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    />
    <player v-show="video.length > 0" :id="videoId" :type="videoType" />
    <b-button @click="handleData">
      Click Me Now {{ videoId }} {{ videoType }}
    </b-button>
  </div>
</template>

<script>
import Player from "@/components/common/player";
import { mapGetters } from "vuex";
export default {
  name: "Display_Church",
  components: {
    Player
  },
  props: {
    resource: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {},
  created() {},
  data() {
    return {
      memoryCards: [],
      flippedCards: [],
      cards: cards,
      finish: false,
      start: false,
      turns: 0,
      totalTime: {
        minutes: 0,
        seconds: 0
      }
    };
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    }),
    video() {
      return this.resource.data &&
        this.resource.data.settings &&
        this.resource.data.settings.video &&
        this.resource.data.settings.video
        ? this.resource.data.settings.video
        : "";
    },
    videoId() {
      return this.video && this.video.videoId
        ? this.video.videoId
        : "E9rvUZ33hJQ";
    },
    videoType() {
      return "youtube";
    },
    settings() {
      if (this.resource && this.resource.data && this.resource.data.settings)
        return this.resource.data.settings; //TDO move to MIXIN
      return null;
    },
    videoURLFromResource() {
      return this.resource.data &&
        this.resource.data.settings &&
        this.resource.data.settings.video &&
        this.resource.data.settings.video.videoURL
        ? this.resource.data.settings.video.videoURL
        : null;
    },
    thumbURLFromResource() {
      return this.resource.data &&
        this.resource.data.settings &&
        this.resource.data.settings.video &&
        this.resource.data.settings.video.thumbURL
        ? this.resource.data.settings.video.thumbURL
        : null;
    }
  },
  methods: {
    handleData() {},
    handleChange(changeMade) {
      //console.log(changeMade);
    }
  }
};
</script>

<style lang="scss" scoped></style>
